import React , { useRef , useState , useEffect } from 'react';
import TopBar from './TopBar';
import { Link , useLocation } from 'react-router-dom'
import logo from '../../assets/images/logo/logo_dark.png'
import logo2x from '../../assets/images/logo/logo_dark@2x.png'
import logolight from '../../assets/images/logo/logo.png'
import logolight2x from '../../assets/images/logo/logo@2x.png'
import logolight3x from '../../assets/images/logo/logo-2.jpg'
import menus from "../../pages/menu";
import DarkMode from "./DarkMode"

import icon from '../../assets/images/icon/connect-wallet.svg'

const Header = () => {
    const { pathname } = useLocation();
    const headerRef = useRef (null)

    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

    const isSticky = (e) => {
        const header = document.querySelector('.js-header');
        const scrollTop = window.scrollY;
        
        scrollTop >= 100 ? header.classList.add('is-fixed') : header.classList.remove('is-fixed');
        scrollTop >= 120 ? header.classList.add('is-small') : header.classList.remove('is-small');
    };

    const menuLeft = useRef(null)
    const btnToggle = useRef(null)

    const menuToggle = () => {
        menuLeft.current.classList.toggle('active');
        btnToggle.current.classList.toggle('active');
    }

    const [activeIndex, setActiveIndex] = useState(null);
    const handleOnClick = index => {
        setActiveIndex(index); 
    };

    const handleSearchClick = () => {
        //redirect to `/explore-01?address=${address}`
        let address = document.getElementById('search').value;
        window.location.href = `/?address=${address}`;
    }
    return <div>
    <header id="header_main" className="header_1 js-header" ref={headerRef}>
          <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                      <div className="mobile-button" ref={btnToggle} onClick={menuToggle}><span></span></div>
                      <div id="site-header-inner" className="flex">
                          <div id="site-logo" className="clearfix">
                              <div id="site-logo-inner">
                                  <img src={logolight3x} style={{width: '95px', background: 'white',borderRadius: '50%', height: '95px'}} onClick={()=> window.location.href = '/'} />
                              </div>
                          </div>
                                 <div className="search-bar flex">
                                     <input type="text" id="search" placeholder="xrpl address" className='search-input' />
                                     <button onClick={handleSearchClick}>Search</button>
                                 </div>
              
                          <nav id="main-nav" className="main-nav" ref={menuLeft}>
                              <ul id="menu-primary-menu" className="menu">
                                  {
                                      menus.map((data,index) => (
                                          <li key={index} onClick={()=> handleOnClick(index)} className={`menu-item menu-item` }   >
                                              {/* <Link to={data.link}>{data.name}</Link> */}
                                              <a href={data.link}>{data.name}</a>
                                          </li>
                                      ))
                                  }
                              </ul>
                          </nav>
                          <DarkMode />
                      </div>
                  </div>
              </div> 
          </div>
      </header>
</div>;
};
//     return <div>
//       <header id="header_main" className="header_1 js-header" ref={headerRef}>
        
//             <div className="container-fluid">
//                 <div className="row">
//                     <div className="col-md-12">
//                         <div id="site-header-inner" className="flex">
//                                 <div className="search-bar flex">
//                                     <input type="text" id="search" placeholder="xrpl address" />
//                                     <button onClick={handleSearchClick}>Search</button>
//                                 </div>
//                             <DarkMode />
//                         </div>
//                     </div>
//                 </div>
//             </div>
            
//         </header>
//   </div>;
// };

export default Header;
